import { ActionTypes } from './actions';

const initialState = {
  allEvents: [],
  eventCountToDisplay: 6,
  isLoading: false,
  isLoaded: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.GET_INITIAL_EVENTS_SUCCESS:
      return {
        ...state,
        allEvents: action.payload,
        isLoaded: true
      };
    case ActionTypes.REMOVE_EVENT:
      return {
        ...state,
        allEvents: state.allEvents.filter((event) => event.id !== action.payload)
      };
    default:
      return state;
  }
}
